/**
 * The Pair is tuple that provides a consistent structure for two values
 */
export type Pair<A, B> = [A, B];

/**
 * Get the first value in a Pair
 */
export const getFirst = <A, B>(pair: Pair<A, B>): A => pair[0];

/**
 * Get the second value in a Pair
 */
export const getSecond = <A, B>(pair: Pair<A, B>): B => pair[1];

/**
 * Create a new Pair
 */
export const pair = <A, B>(first: A, second: B): Pair<A, B> => [first, second];
